import React, { useCallback, useEffect, useRef, useState } from "react";
import BasicTable from "../../../Components/CommonTable/BasicTable/BasicTable.jsx";
import {
  canlenderFilter,
  Columns,
  filters,
  searchBy,
} from "../../../service/subcategoryService.js";
import { useFetchAll } from "../../../custom/FetchApiHook.jsx";
// import OrderModal from "./OrderModal/OrderModal.jsx";
import { SubCategoryApi } from "../../../App/api/menu.apis.js";
import AddSubCategory from "./AddSubCategory.jsx";
// import StoreModal from "../../../Components/Modals/StoreModal/StoreModal.jsx";

const SubCategoryComp = ({
  disabledFilters,
  pagination,
  handlePagination,
  accessSubCategory,
}) => {
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);
  const { value, fetchAllData } = useFetchAll(() =>
    SubCategoryApi.getSubCategory(pagination, search)
  );
  const [selectedSubcategory, ] = useState(null);
  const [addSubcategory, setAddSubcategory] = useState(false);
  const [editSubcategory, setEditSubcategory] = useState(null);

  console.log("value SubCategoryComp", value?.data?.subcategories);

  const closeSubCategoryModal = () => {
    setAddSubcategory(false);
    setEditSubcategory(null);
  };

  // const handleRowClick = (row) => {
  //   console.log("row", row);
  //   setSelectedSubcategory(row);
  //   setAddSubcategory(true);
  // };
  const handleCellClick = (cell, field = "") => {
    if (field === "Subcategory") {
      setEditSubcategory(cell);
      setAddSubcategory(true);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      console.log("Paginator Clicked", e);
      //  const row={
      //   filters: null,
      //   first: 0,
      //   multiSortMeta: [],
      //   page: 0,
      //   rows: 10,
      //   sortField: null,
      //   sortOrder: null,
      //   totalPages: 2
      // }
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
      // handlePagination && handlePagination(e.row,limit,sortOrder,filter)
    }
  };

  const handleSearch = useCallback((s) => {
    // console.log('Search at OrderCom', s);
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    handlePagination && handlePagination({ clearPagination });
  };
  const handleFilter = (name, value) => {
    console.table("name,value", name, value);
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    // console.log("data", data);
    handlePagination && handlePagination(data);
  };

  // console.log("pagination", pagination);
  // // console.log("search",search);
  // // console.log("filters",filters);
  // // console.log("debouncedSearch",debouncedSearch);

  useEffect(() => {
    fetchAllData();
  }, [pagination, search]);

  const DataFilter = filters.filter((f) =>
    disabledFilters ? !disabledFilters.includes(f.inputName) : true
  );

  return (
    <div className="p-5">
      <BasicTable
        // data={[]}
        columns={Columns}
        data={value?.data?.subcategories}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: value?.data?.page || 1,
          rows: value?.data?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: value.data?.totalPages || 1,
          totalCount: value.data?.totalCount || 1,
        }}
        onCellClick={(e) => {
          console.log("Cell Data", e);
        }}
        SearchBy={searchBy}
        handleSearch={debouncedSearch}
        handleFilter={(name, value) => handleFilter(name, value)}
        handleClearFilter={handleClearFilter}
        filters={DataFilter}
        WeekRange={false}
        MonthRange={true}
        canlenderFilter={canlenderFilter}
        selectedData={selectedSubcategory}
        handleCellClick={(cell, field)=>accessSubCategory?.update ? handleCellClick(cell,field) : () => {}}
        // handleRowClick={(row) => handleRowClick(row)}
        button_name={accessSubCategory.read && "Add"}
        handleButton={() => {
          setAddSubcategory(true);
        }}
      />
      <AddSubCategory
        getAllData={fetchAllData}
        currentItems={editSubcategory}
        open={addSubcategory}
        handleClose={() => closeSubCategoryModal()}
      />
    </div>
  );
};

export default SubCategoryComp;
